<template>
  <el-card class="box-card" v-loading="!record.processing">
    <audit-file-detail-object :ref="record.id" :id="record.id" />
    <div class="row">
      <div class="col-8">
        <p>{{ record.createdAt }}</p>
        <p class="time">Enviado por {{ record.createdBy }}</p>
      </div>
      <div class="col-4 text-end">
        <div class="icon icon-shape bg-gradient-green shadow-primary text-center rounded-circle right" v-if="record.processing">
          <i class="ni ni-check-bold text-lg opacity-10" aria-hidden="true"></i>
        </div>
        <div class="icon icon-shape bg-gradient-orange shadow-primary text-center rounded-circle right" v-else>
          <i class="fa fa-spinner text-lg opacity-10" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="w-100">
          <el-tag type="info" title="Quantidade objetos da planilha" class="w-25 text-center"><i class="el-icon-medal mr-1"></i>{{ record.total }}</el-tag>
          <el-tag type="warning" title="Objetos já tratados" class="w-25 text-center"><i class="el-icon-aim mr-1"></i>{{ record.already }}</el-tag>
          <el-tag type="danger" title="Quantidade objetos que ficaram pendentes de verificação" class="w-25 text-center"><i class="el-icon-finished mr-1"></i>{{ record.pendencies }}</el-tag>
          <el-tag type="success" title="Objetos corrigidos automaticamente" class="w-25 text-center"><i class="el-icon-check mr-1"></i>{{ record.success }}</el-tag>
        </p>
      </div>
    </div>
    <div class="bottom clearfix">
      <el-button-group class="w-100">
        <el-button title="Objetos" class="w-50" @click="open(record.id)" :disabled="!record.processing" type="default" icon="el-icon-truck"><span class="hidden-lg-and-down">Objetos</span></el-button>
        <el-button title="Download" class="w-50" @click="download(record.id)" :disabled="!record.processing" type="default" icon="el-icon-download"><span class="hidden-lg-and-down">Download</span></el-button>
      </el-button-group>
    </div>          
  </el-card>
</template>

<script>
import { AuditService } from "@/services/customers/audit.services";
import AuditFileDetailObject from './AuditFileDetailObject';

export default {
  props: ["record"],
  components: {
    AuditFileDetailObject,
  },
  methods: {
    open() {
      this.$refs[this.record.id].open();
    },
    download(id) {
      const vm = this;
      vm.loading = true;
      AuditService.download(id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${id}.csv`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => vm.loading = false);
    },
  }
}
</script>


<style scoped>
.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.w-25 {
  width: 25%;
}

.mr-1 {
  margin-right: 1px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}
.ni {
  color: #fff;
}
.fa {
  color: #fff;
}

</style>